import React, { useState, useEffect, useCallback } from 'react';
import { useMotion } from '../../context/MotionContext';

const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
const MAX_SCRAMBLE_DURATION = 350; // Max 350ms as per spec

const GlitchText = ({ text, className = '' }) => {
  const [displayText, setDisplayText] = useState(text);
  const [isHovering, setIsHovering] = useState(false);
  const { prefersReducedMotion } = useMotion();

  const scramble = useCallback(() => {
    if (prefersReducedMotion) return;

    let iterations = 0;
    const maxIterations = Math.min(text.length * 2, 12); // Cap iterations for performance
    const intervalTime = MAX_SCRAMBLE_DURATION / maxIterations;
    
    const interval = setInterval(() => {
      setDisplayText(
        text
          .split('')
          .map((char, index) => {
            if (char === ' ') return ' ';
            if (index < iterations / 2) return text[index];
            return chars[Math.floor(Math.random() * chars.length)];
          })
          .join('')
      );

      iterations++;

      if (iterations >= maxIterations) {
        clearInterval(interval);
        setDisplayText(text);
      }
    }, intervalTime);

    return () => clearInterval(interval);
  }, [text, prefersReducedMotion]);

  useEffect(() => {
    if (isHovering && !prefersReducedMotion) {
      const cleanup = scramble();
      return cleanup;
    }
  }, [isHovering, scramble, prefersReducedMotion]);

  // If reduced motion, just render text
  if (prefersReducedMotion) {
    return <span className={className}>{text}</span>;
  }

  return (
    <span
      className={`inline-block ${className}`}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => {
        setIsHovering(false);
        setDisplayText(text);
      }}
    >
      {displayText}
    </span>
  );
};

export default GlitchText;
